import { render, staticRenderFns } from "./ImportReviewFilters.vue?vue&type=template&id=13fa7a04&"
import script from "./ImportReviewFilters.vue?vue&type=script&lang=js&"
export * from "./ImportReviewFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports